// 参照: https://react.dev/learn/scaling-up-with-reducer-and-context

import { createContext, useReducer } from 'react';

export const draggableModelessDialogOrdersChangeActionTypes = ['added', 'changed', 'deleted'] as const;
// ↓ 配列から union type を定義。
/** DraggableModelessDialogOrdersChangeAction.type の union type。 */
export type DraggableModelessDialogOrdersChangeActionType = typeof draggableModelessDialogOrdersChangeActionTypes[number];

/** 表示順序の型。ID の配列。 */
export type DraggableModelessDialogOrders = (number | string)[];
/** 表示順序を変更する Action。 */
export type DraggableModelessDialogOrdersChangeAction = {
  type: DraggableModelessDialogOrdersChangeActionType;
  id: number | string;
  // indexFrom?: number | undefined;
  order?: number | undefined;
};

/** 表示順序の Context。 */
export const DraggableModelessDialogOrdersContext = createContext<DraggableModelessDialogOrders | undefined>(undefined);
/** 表示順序の変更用 dispatch function の Context。 */
export const DraggableModelessDialogOrdersDispatchContext = createContext<typeof ordersReducer | undefined>(undefined);

/** 複数の DraggableModelessDialogs の表示順序を管理するための Context Provider。 */
function DraggableModelessDialogsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [orders, dispatch] = useReducer(ordersReducer, []);

  return (
    <DraggableModelessDialogOrdersContext.Provider value={orders}>
      <DraggableModelessDialogOrdersDispatchContext.Provider value={dispatch as never}>
        {children}
      </DraggableModelessDialogOrdersDispatchContext.Provider>
    </DraggableModelessDialogOrdersContext.Provider>
  );
}

export default DraggableModelessDialogsProvider;

function ordersReducer(
  orders: DraggableModelessDialogOrders,
  action: DraggableModelessDialogOrdersChangeAction
): DraggableModelessDialogOrders {
  switch (action.type) {
    case 'added': {
      // ↓ 冗長だが、TypeScript 故に仕方ないか。
      if (typeof action.id === 'number') {
        return (orders as number[]).concat(action.id);
      }
      return (orders as string[]).concat(action.id);
    }

    case 'changed': {
      // クローン。
      const newOrders = [...orders];
      if (orders.includes(action.id)) {
        // 元の位置から除いて、
        newOrders.splice(orders.indexOf(action.id), 1);
      }
      // 新しい位置に挿入。
      newOrders.splice(action.order as number, 0, action.id);
      return newOrders;
    }

    case 'deleted': {
      // ↓ 冗長だが、TypeScript 故に仕方ないか。
      if (typeof action.id === 'number') {
        return (orders as number[]).filter((order: number) => order !== action.id);
      }
      return (orders as string[]).filter((order: string) => order !== action.id);
    }

    default: {
      throw Error(`Unknown action: ${action.type as DraggableModelessDialogOrdersChangeActionType}`);
    }
  }
}